(function () {

  let pplrPendingKeys = new Set();

  function isZeroPrice(text) {
    const digits = text.replace(/[^\d]/g, '');
    return digits !== '' && parseInt(digits, 10) === 0;
  }

  function getFallbackText() {
    const text = window.themeStrings?.price_pending_note;
    return (!text || text.indexOf('cart.general.') === 0)
      ? 'Preis wird nach Bestätigung berechnet'
      : text;
  }

  function getFallbackTextShort() {
    const text = window.themeStrings?.price_pending;
    return (!text || text.indexOf('cart.general.') === 0)
      ? 'Preis wird nach Bestätigung berechnet'
      : text;
  }

  function isPplrPending(item) {
    const dataId = item.getAttribute('data-product-id');
    if (!dataId) return false;
    return pplrPendingKeys.has(dataId);
  }

function processItemMoney(item) {
    injectStyle();
    item.classList.add('pplr-pending');

    const qbCreated = item.querySelectorAll('[data-integration-price-created] .money');
    const hasQb = qbCreated.length > 0;

    if (hasQb) {
      // DK-стиль: QB контейнер видимый, скрываем только .money внутри
      qbCreated.forEach(function(m) {
        if (m.style.display === 'none') return;
        m.style.display = 'none';
        const parent = m.parentNode;
        if (!parent.querySelector('.pplr-price-warning')) {
          const warning = document.createElement('div');
          warning.className = 'pplr-price-warning';
          const isOffers = parent.closest('.offers') !== null;
          warning.textContent = isOffers ? getFallbackTextShort() : getFallbackText();
          warning.style.fontSize = '12px';
          warning.style.color = '#888';
          warning.style.marginTop = '4px';
          parent.appendChild(warning);
        }
      });
    } else {
      // DE-стиль: добавляем предупреждение в offersDiv
      const priceField = item.querySelector('.price-field');
      if (!priceField) {
        const offersDiv = item.querySelector('.two:not(.total-line):not(.item-thumb)');
        if (offersDiv && !offersDiv.querySelector('.pplr-price-warning')) {
          const warning = document.createElement('div');
          warning.className = 'pplr-price-warning';
          warning.textContent = getFallbackTextShort();
          warning.style.fontSize = '12px';
          warning.style.color = '#888';
          warning.style.marginTop = '4px';
          offersDiv.appendChild(warning);
        }
      }
    }

    // остальные .money без QB атрибутов
    item.querySelectorAll('.money').forEach(function(moneyEl) {
      const skipParent = moneyEl.closest('[data-integration-price-original], [data-integration-price-created]');
      if (skipParent) return;
      if (moneyEl.style.display === 'none') return;
      moneyEl.style.display = 'none';
      const parent = moneyEl.parentNode;
      if (!parent.querySelector('.pplr-price-warning')) {
        const warning = document.createElement('div');
        warning.className = 'pplr-price-warning';
        warning.textContent = getFallbackTextShort();
        warning.style.fontSize = '12px';
        warning.style.color = '#888';
        warning.style.marginTop = '4px';
        parent.appendChild(warning);
      }
    });
  }

  function processItem(item) {
    if (!item.classList.contains('pplr_cart_row')) return;
    if (!isPplrPending(item)) return;

    const totals = item.querySelectorAll('.qb-total-line-item');
    totals.forEach(function (totalEl) {
      if (!isZeroPrice(totalEl.textContent)) return;
      totalEl.style.display = 'none';
      if (item.querySelector('.pplr-price-warning')) return;
      const warning = document.createElement('div');
      warning.className = 'pplr-price-warning';
      warning.textContent = getFallbackText();
      warning.style.fontSize = '12px';
      warning.style.color = '#888';
      warning.style.marginTop = '4px';
      totalEl.parentNode.appendChild(warning);
    });

    const priceEl = item.querySelector('.price-field');
    if (priceEl && isZeroPrice(priceEl.textContent)) {
      priceEl.textContent = getFallbackText();
    }

    // для KONFIGURATOREN: только если нет стандартных PPLR элементов
    const hasStandardPplr = totals.length > 0 || priceEl;
    if (!hasStandardPplr) {
      processItemMoney(item);
    }
  }

  function applyFallback() {
    // стандартные PPLR товары
    document.querySelectorAll('.item.pplr_cart_row').forEach(processItem);

    // товары без pplr_cart_row (KONFIGURATOREN после QB обновления)
    pplrPendingKeys.forEach(function(key) {
      const el = document.querySelector(`[data-product-id="${key}"]`);
      if (el && !el.classList.contains('pplr_cart_row')) {
        processItemMoney(el);
      }
    });
  }

function injectStyle() {
    const existing = document.getElementById('pplr-pending-style');
    const hasQb = !!document.querySelector('[data-integration-price-created]');
    
    // если стиль уже правильный — не пересоздаём
    if (existing) {
      if (hasQb && existing.textContent.includes('[data-integration-price-created]:has')) return;
      if (!hasQb && existing.textContent.includes('[data-integration-price-created] { display: none')) return;
      existing.remove(); // стиль неправильный — удаляем и создаём заново
    }

    const style = document.createElement('style');
    style.id = 'pplr-pending-style';
    style.textContent = hasQb ? `
      .pplr-pending [data-integration-price-original] { display: none !important; }
      .pplr-pending .qb-total-line-item { display: none !important; }
      .pplr-pending [data-integration-price-created]:has(.pplr-price-warning) { display: inline-block !important; }
      .pplr-pending .total-line[data-integration-price-created]:has(.pplr-price-warning) { display: none !important; }
    ` : `
      .pplr-pending [data-integration-price-original] { display: none !important; }
      .pplr-pending [data-integration-price-created] { display: none !important; }
      .pplr-pending .qb-total-line-item { display: none !important; }
      .pplr-pending .total-line { display: none !important; }
    `;
    document.head.appendChild(style);
  }

  function loadCartAndInit() {
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => {
        const PPLR_PRICE_THRESHOLD = window.PPLR_PRICE_THRESHOLD || 0;
        const PPLR_PENDING_TYPES = ['PPLR_HIDDEN_PRODUCT', 'KONFIGURATOREN'];

        (cart.items || []).forEach(item => {
          if (PPLR_PENDING_TYPES.includes(item.product_type) && item.final_price <= PPLR_PRICE_THRESHOLD) {
            const isAutoAdded = item.properties && item.properties['_auto_added'] === 'true';
            if (!isAutoAdded) {
              pplrPendingKeys.add(item.key);
            }
          }
        });
        // fallback flag for Flow
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            attributes: {
              _pplr_price_check: pplrPendingKeys.size > 0 ? 'true' : ''
            }
          })
        });

        applyFallback();

        const observer = new MutationObserver(function (mutations) {
          for (const m of mutations) {
            if (m.addedNodes.length) {
              applyFallback();
              break;
            }
          }
        });

        observer.observe(document.body, {
          childList: true,
          subtree: true
        });
      })
      .catch(err => console.warn('⚠️ pplr-price-fallback: cart.js error', err));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', loadCartAndInit);
  } else {
    loadCartAndInit();
  }

})();